import { withStyles } from '@material-ui/core/styles';
import ViewWrapper from 'views/ViewWrapper';
import MuiGrid from '@material-ui/core/Grid';
import MuiPaper from '@material-ui/core/Paper';
import MuiTypography from '@material-ui/core/Typography';
import LinkfireHistoryTable from './linkfire-history-table';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
});

const LinkfireIngestionHistory = ({ ...props }) => {
  const { classes } = props;

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Linkfire Ingestion History
          </MuiTypography>
          <LinkfireHistoryTable />
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(LinkfireIngestionHistory);
